import { cn } from '@/lib/utils';
import { Link } from '@inertiajs/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const baseBtn = 'flex h-9 min-w-9 items-center justify-center rounded-sm border px-3 text-sm transition';
const inactiveBtn = 'border-gray-200 text-gray-700 hover:border-gray-400';
const activeBtn = 'border-[#800020] bg-[#800020] text-white';
const disabledBtn = 'opacity-40 pointer-events-none';
function buildPages(current, total) {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages = [1];
    if (current > 3)
        pages.push('gap');
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);
    for (let i = start; i <= end; i++)
        pages.push(i);
    if (current < total - 2)
        pages.push('gap');
    pages.push(total);
    return pages;
}
export default function Pagination({ currentPage, totalPages, onPageChange, links, className, }) {
    if (links) {
        return <LinkPagination links={links} className={className}/>;
    }
    if (totalPages <= 1)
        return null;
    const pages = buildPages(currentPage, totalPages);
    return (<nav className={cn('flex items-center justify-center gap-2', className)} aria-label="Pagination">
            <button type="button" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className={cn(baseBtn, inactiveBtn, currentPage === 1 && disabledBtn)} aria-label="Previous page">
                <ChevronLeft className="h-4 w-4"/>
            </button>

            {pages.map((p, i) => p === 'gap' ? (<span key={`gap-${i}`} className="px-1 text-gray-400">
                        …
                    </span>) : (<button key={p} type="button" onClick={() => onPageChange(p)} aria-current={p === currentPage ? 'page' : undefined} className={cn(baseBtn, p === currentPage ? activeBtn : inactiveBtn)}>
                        {p}
                    </button>))}

            <button type="button" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className={cn(baseBtn, inactiveBtn, currentPage === totalPages && disabledBtn)} aria-label="Next page">
                <ChevronRight className="h-4 w-4"/>
            </button>
        </nav>);
}
function LinkPagination({ links, className }) {
    if (!Array.isArray(links) || links.length <= 3)
        return null;
    const prev = links[0];
    const next = links[links.length - 1];
    const numbered = links.slice(1, -1);
    return (<nav className={cn('flex items-center justify-center gap-2', className)} aria-label="Pagination">
            {prev.url ? (<Link href={prev.url} className={cn(baseBtn, inactiveBtn)} aria-label="Previous page" preserveScroll>
                    <ChevronLeft className="h-4 w-4"/>
                </Link>) : (<span className={cn(baseBtn, inactiveBtn, disabledBtn)} aria-hidden="true">
                    <ChevronLeft className="h-4 w-4"/>
                </span>)}

            {numbered.map((link, i) => !link.url ? (<span key={`gap-${i}`} className="px-1 text-gray-400">
                        …
                    </span>) : (<Link key={link.label} href={link.url} aria-current={link.active ? 'page' : undefined} className={cn(baseBtn, link.active ? activeBtn : inactiveBtn)} preserveScroll>
                        {link.label}
                    </Link>))}

            {next.url ? (<Link href={next.url} className={cn(baseBtn, inactiveBtn)} aria-label="Next page" preserveScroll>
                    <ChevronRight className="h-4 w-4"/>
                </Link>) : (<span className={cn(baseBtn, inactiveBtn, disabledBtn)} aria-hidden="true">
                    <ChevronRight className="h-4 w-4"/>
                </span>)}
        </nav>);
}
